import { z } from "zod";

export const bookMonthSchema = () =>
  z.object({
    month: z.number({ required_error: "Mês é obrigatório" }).min(0).max(11),
    year: z.number({ required_error: "Ano é obrigatório" }).min(2000),
  });

export type BookMonthFormValues = z.infer<ReturnType<typeof bookMonthSchema>>;
